import * as React from "react";
import { v4 } from "uuid";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Checkbox from '@material-ui/core/Checkbox';

import "./../../resources/forest.jpg";

import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import {TaskOption,ExerciseType} from '../server/ExamServer'


import Login from "./Login";



const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});

export interface ExamOptionProps {
    option:TaskOption
    disabled:boolean
    type:ExerciseType
    onSelect:(option: TaskOption) => void
}

export interface ExamOptionState {

}


class ExamOption extends React.Component<ExamOptionProps, ExamOptionState> {


    constructor(props: ExamOptionProps) {
        super(props);
    }

    handleSelect = () => {
        this.props.onSelect && this.props.onSelect(this.props.option);
    }
    

    render() {

        const {option, disabled, type} = this.props

        let color:"primary"|"default" = option.checked && option.checked?"primary":"default";
        let stateColor = "";

        if(typeof option.expected == "boolean" && typeof option.checked !== "undefined" && option.checked === true){
            stateColor = option.expected == option.checked?green[300]:red[300]
        }



        return (
            <React.Fragment>
                {type === ExerciseType.Multi?(
                    <Button
                        variant="text"
                        color={color}
                        onClickCapture={option.expected == undefined?this.handleSelect:undefined}
                        style={{margin:theme.spacing(1), backgroundColor:stateColor}}
                    >{option.content + (option.content2?(" / " +option.content2):"")}</Button>
                ):null}

                {type === ExerciseType.Check?(
                    <React.Fragment>
                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={option.checked && option.checked?true:false}
                                onChange={option.expected == undefined?this.handleSelect:undefined}
                                style={{color:stateColor}}
                                //value={option.content}
                                color={color}
                            />
                        }
                        label={option.content + (option.content2?(" / " +option.content2):"")}
                    />
                  </React.Fragment>
                    
                ):null}


            </React.Fragment>

        );
    }
}

export default ExamOption;
